import { IS_TEST_ENV } from '@app/constants';

export const RECORDS_PER_PAGE = IS_TEST_ENV ? 3 : 25;
export const MAX_CONTRIBUTORS_TO_DISPLAY = 3;
